import styled from 'styled-components'

export const PrimaryButton = styled.div`
  a,
  button {
    max-width: 15rem;
    border: 1px solid ${props => props.theme.colors.black};
    line-height: 1;
    padding: 1.1rem 1rem 0.9rem;
    border-radius: 5rem;
    display: block;
    font-size: 1.4rem;
    text-decoration: none;
    color: ${props => props.theme.colors.black};
    position: relative;
    text-align: center;
    margin: auto;
    cursor: pointer;

    &.externalLink {
      &:before {
        content: '';
        background-image: url(../external-link.svg);
        height: 1rem;
        width: 1rem;
        position: absolute;
        right: 2.5rem;
        top: 1.2rem;

        @media screen and (min-width: ${props => props.theme.responsive.small}) {
          width: 1.2rem;
          height: 1.2rem;
          right: 3.6rem;
          top: 1.9rem;
        }
      }
    }

    &::before,
    &::after {
      transition: none;
      background-color: transparent;
    }

    &:hover,
    &:focus {

      &::before,
      &::after {
        left: auto;
      }
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      font-size: 1.6rem;
      max-width: 27rem;
      padding: 1.7rem 1.6rem;
      margin: ${props => props.center ? '0 auto' : '0'};
    }
  }
`

export const ButtonArrow = styled.svg`
  display: block;
  width: 12px;
  height: 12px;
  float: right;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    vertical-align: middle;
    margin-top: 0.1rem;
  }
`

export const BannerButton = styled(PrimaryButton)`
  text-align: center;
  margin-top: 6.4rem;

  a {
    display: inline-block;
    border: 1px solid ${props => props.theme.colors.white};
    min-width: 14.8rem;
    font-size: 1.4rem;
    border-radius: 3rem;
    color: ${props => props.theme.colors.white};
    background: transparent;
    margin: 0 auto;

    &::after {
      display: none;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      min-width: 27rem;
      font-size: 1.6rem;
      padding: 1.5rem 1.6rem;
      max-width: ${props => props.theme.sizes.maxWidthCentered};
    }
  }
`

export const LoadMoreButton = styled(PrimaryButton)`
  text-align: center;

  button {
    display: block;
    width: 100%;
    font-size: 1.6rem;
    padding: 1.5rem 1.6rem;
    margin: 2rem auto;
    max-width: 100%;
    color: ${props => props.theme.colors.black};
    background: ${props => props.theme.colors.inputBG};
    border: 1px solid ${props => props.theme.colors.inputBG};

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      max-width: 27rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      display: inline-block;
      padding: 1.7rem 1.6rem;
    }
  }
`

export const SecondaryButton = styled(PrimaryButton)`
  &.centerAlign {
    text-align: center;
  }

  button,
  a {
    display: inline-block;
    padding: 1.1rem 0.9rem 0.9rem;
    font-size: 1.2rem;
  }
`
